import CognitoUserList from './abstract/CognitoUserList'
import Config from '../../../Config'

class CompanyUserList extends CognitoUserList {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, adminUserList: ''}
    this.apiUrl = Config.companyAdminApiUrl.companyUser
    this.userRoleName = '企業ユーザー'
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
}

export default CompanyUserList



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/CompanyUserList.js